<template>
    <div class="">
        <div >
            <h5>Paso 2: [Opcional] Ordene el contenido según su prioridad y guarde los cambios</h5>
            <hr />
            <div v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado' || obtenerPaginaWebId == 29 || obtenerPaginaWebId == 1">
                    <h6><b>Descripción de los iconos</b>&nbsp;<i class="fas fa-caret-down fa-lg" @click="mostrarDescripcionDeIconos = !mostrarDescripcionDeIconos"></i></h6>
                <table id="descripcion-iconos-table" class="col-12" v-if="mostrarDescripcionDeIconos">
                    <tbody>
                    <tr>
                            <td><i class="fas fa-eye fa-lg p-1"></i></td>
                            <td v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'"><h6><b>Mostrar en inicio:</b>&nbsp;Representa los contenidos que se mostrarán en el menú lateral derecho de la página oficial.</h6></td>
                            <td v-if="obtenerPaginaWebId == 29"><h6><b>Mostrar en inicio:</b>&nbsp;Representa el boletín electrónico que se mostrará en la barra superior de la página oficial.</h6></td>
                            <td v-if="obtenerPaginaWebId == 1"><h6><b>Mostrar en inicio:</b>&nbsp;Representa el informe laboral que se mostrará en la barra superior de la página oficial.</h6></td>
                    </tr>
                    <tr v-if="obtenerPaginaWebId == 19">
                            <td><i class="fas fa-exclamation fa-lg p-1"></i></td>
                            <td><h6><b>Noticia Urgente:</b>&nbsp;Representa la noticia con estatus de urgente que se mostrará como sección emergente al momento de visitar la página oficial.</h6></td>
                    </tr>
                    <tr v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'">
                            <td><i class="fas fa-thumbtack fa-lg p-1"></i></td>
                            <td><h6><b>Pin:</b>&nbsp;Representa el contenido que se fijará al inicio dentro del menú lateral derecho de la página oficial, si éste está activo también lo estará mostrar en inicio.</h6></td>
                    </tr>
                    <tr v-if="obtenerPaginaWebId == 19">
                            <td><i class="fas fa-layer-group fa-lg p-1"></i></td>
                            <td><h6><b>Disposición Especial:</b>&nbsp;Representa los contenidos que son dispisición especial y tendrán un vínculo directo en el menú de "Disposiciones Especiales" de la página oficial.</h6></td>
                    </tr>
                    </tbody>
                </table>
                <hr/>
            </div>
            <div class="listaOrdenable_div row-5">
                <ListaOrdenableDeContenido></ListaOrdenableDeContenido>
            </div>
        </div>
        <div class="text-right">
            <div>
                <br>
                <button type="button" class="btn btn-primary text-center" data-toggle="modal" data-target="#exampleModal" @click="guardarOrdenDeContenidos()">Guardar Orden</button>
            </div> 
        </div>  
    </div>  
</template>

<script>
    import enumeraciones from '@/../static/js/enumeraciones'
    import api from '@/../static/js/api'
    import comun from '@/../static/js/comun'
    import axios from 'axios'
    import ListaOrdenableDeContenido from '@/components/SICPO/PaginaWeb/AltaDeContenido/ListaOrdenableDeContenido.vue'

    export default {
        components: {
            ListaOrdenableDeContenido
        },
        data() {
            return {
                mostrarDescripcionDeIconos: false,
                ordenEditadoBandera: false,
                listaDeContenidosNuevoOrden: []
            };
        },
        methods: {
            /**
             * Metodo encargado de modificar el orden de los contenidos guardados en base de datos..  
             */
            guardarOrdenDeContenidos: function() {
                comun.SeEstaCargandoInformacion(true);
                this.generarListadoConNuevoOrden();
                let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
                const parametros = {}
                parametros.ContenidosDeLaPaginaWeb = this.listaDeContenidosNuevoOrden;
                parametros.SeccionDeLaPaginaWebId = this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
                parametros.EsComunicado = esComunicado;

                // api.SICPO.funcion.ModificarOrdenDeContenidosComunicados
                const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.ModificarOrdenDeContenidosComunicados;

                axios.post(api.conexion + METODO_API_AGREGAR,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                    comun.SeEstaCargandoInformacion(false);
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                }).catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });
            },
            /**
             * Metodo encargado de asignar el nuevo orden que tendra cada uno de los contenidos de la lista, desplazando
             * un lugar antes o despues segun la interaccion del usuario.  
             */
            generarListadoConNuevoOrden: function() {
                this.listaDeContenidosNuevoOrden = [];
                let listado = this.obtenerListaDeContenidosOriginal;
                for(var i=0;i<listado.length;i++){
                    let contenido = listado[i].contenido;
                    contenido.OrdenDelContenido = i+1;
                    this.listaDeContenidosNuevoOrden.push(contenido);
                }
            },
        },
        computed: {
            obtenerCamposRequeridosEnFormulario() {
                return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario;
            },
            obtenerListaDeContenidosOriginal() {
                return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
            },
            obtenerPaginaWebId() {
                return this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
            }
        }
    }
</script>

<style scoped>
    .listaOrdenable_div
    {
        background-color: #57585B;
        padding: 0.5%;
        min-height: 300px;
        max-height: 700px;
        overflow: auto;
        border-style: solid;
        border-color: #57585B;
        border-width: 1px;
        border-bottom-width: 3px;
    }
    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    .fa-caret-down:hover{
        cursor: pointer;
    }
    #descripcion-iconos-table h6, #descripcion-iconos-table i{
        color: white !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/AltaDeContenido/CFormularioPasoTres.vue